import styled, {css} from 'styled-components'
import {
    TooltipTrigger as AriaTooltipTrigger,
    Tooltip as AriaTooltip,
    OverlayArrow as AriaOverlayArrow,
    Button as AriaButton,
} from 'react-aria-components'

export const TooltipCSS = css`
    background-color: white;
    padding: 4px;
    box-shadow:
        0 10px 15px -3px rgba(0, 0, 0, 0.1),
        0 4px 6px -4px rgba(0, 0, 0, 0.1);
`

export const TooltipTrigger = styled(AriaTooltipTrigger)`
    position: relative;
    display: inline-block;
`

export const Tooltip = styled(AriaTooltip)<{
    maxWidth?: string
}>`
    ${TooltipCSS}
    font-size: 14px;
    color: black;
    position: absolute;
    z-index: 1000;
    max-width: ${({maxWidth}) => maxWidth || '200px'};
    opacity: 0;
    visibility: hidden;
    transform: scale(0.95);
    transition:
        opacity 0.15s ease-out,
        transform 0.15s ease-out,
        visibility 0.15s ease-out;
    border: 1px solid black;
    border-radius: 5px;
    will-change: opacity, transform;

    &[data-placement] {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
    }
`

export const OverlayArrow = styled(AriaOverlayArrow)``

export const TriggerWrapper = styled(AriaButton)`
    cursor: auto;
    outline: none;
    border: none;
    background: none;
    padding: 0;
    margin: 0;
    appearance: none;
    color: inherit;
    font: inherit;
`
